import { mediumCommandBarDensity } from '../components/commandbar/mediumCommandBar';
import { fullCommandBarDensity } from '../components/commandbar/fullCommandBar';
import { compactCommandBarDensity } from '../components/commandbar/compactCommandBar';
import type { PartialTheme } from '@fluentui/theme';

export function getCommandBarTheme(hasDensityNext: boolean, densityModeString: string) {
    if (!hasDensityNext) {
        return {};
    }

    if (densityModeString === 'compact') {
        return compactCommandBarDensity;
    } else if (densityModeString === 'medium') {
        return mediumCommandBarDensity;
    } else {
        return fullCommandBarDensity;
    }
}

export function getNewMessageButtonTheme(
    densityModeString: string,
    isSplitButton: boolean
): PartialTheme {
    if (densityModeString === 'compact') {
        return newMessageButtonStyle(4, isSplitButton);
    } else if (densityModeString === 'medium') {
        return newMessageButtonStyle(6, isSplitButton);
    } else {
        return newMessageButtonStyle(8, isSplitButton);
    }
}

const newMessageButtonStyle = (rightSpacing: number, isSplitButton: boolean) => {
    //Split button needs padding to maintain its hover state accurate
    if (isSplitButton) {
        const rightPadding = (rightSpacing + 12).toString() + 'px';
        return {
            components: {
                CommandBarButton: {
                    styles: { root: { padding: '0px ' + rightPadding + ' 0px 24px' } },
                },
            },
        };
    }

    const marginRight = rightSpacing.toString() + 'px';
    return {
        components: {
            CommandBarButton: {
                styles: { root: { margin: '6px ' + marginRight + ' 6px 12px' } },
            },
        },
    };
};
